import { Box, Skeleton } from "@mui/material";

export const SkeletonDashboardExamCodes: React.FC = () => (
    <Box
        sx={{
            flexGrow: 1,
            overflowY: "auto",
            maxHeight: 5 * 72,
            pr: 1.5,
        }}
    >
        {[1, 2, 3].map((i) => (
            <Box
                key={i}
                sx={{
                    backgroundColor: i % 2 === 0 ? "#F7F8FD" : "#FFFFFF",
                    width: "100%",
                    borderRadius: "8px",
                    p: "14px 16px",
                    mb: 1.5,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "13px",
                    }}
                >
                    {/* LEFT SIDE SKELETON */}
                    <Box sx={{ display: "flex", flexDirection: "column", width: "60%" }}>
                        {/* Exam Name */}
                        <Skeleton variant="text" width="70%" height={18} />

                        {/* Total + Available row */}
                        <Box sx={{ display: "flex", gap: 3, mt: 1 }}>
                            <Skeleton variant="text" width={90} height={14} />
                            <Skeleton variant="text" width={90} height={14} />
                        </Box>
                    </Box>

                    {/* RIGHT SIDE — Exam Code pill skeleton */}
                    <Skeleton
                        variant="rounded"
                        width={100}
                        height={36}
                        sx={{
                            borderRadius: "6px",
                            flexShrink: 0,
                        }}
                    />
                </Box>
            </Box>
        ))}
    </Box>
);